import { useCallback, useEffect, useState } from 'react';
import { type Waypoint } from 'react-waypoint';
import useGetShouldRenderBelowSpinner from '~/hooks/vdp/selectors/useGetShouldRenderBelowSpinner';

const useBannerState = () => {
  const trigger = useGetShouldRenderBelowSpinner();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (
      (document?.documentElement?.scrollTop || document?.body?.scrollTop) > 250
    ) {
      setShowBanner(true);
    }
  }, [trigger]);

  const handleBannerTransition = useCallback(
    ({ currentPosition, previousPosition }: Waypoint.CallbackArgs) => {
      if (currentPosition === 'above' && previousPosition === 'inside') {
        setShowBanner(true);
      }
      if (currentPosition === 'inside' && previousPosition === 'above') {
        setShowBanner(false);
      }
    },
    []
  );

  return { showBanner, handleBannerTransition };
};

export default useBannerState;
